import { useState } from 'react';
import DesignCheckbox from 'components/designCheckbox/DesignCheckbox';
import { FilterIcon } from 'components/svgs';
import DesignButton from '../button/DesignButton';

export interface EventsFilteringDropdownProps {
  filterHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedFilters: string[];
}

const EventsFilteringDropdown = ({
  filterHandler,
  selectedFilters,
}: EventsFilteringDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleDropdownClick = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="relative z-40">
      <DesignButton
        onClickHandler={handleDropdownClick}
        className="flex items-center justify-between gap-2"
      >
        <div className="flex items-center gap-2">
          <FilterIcon className="dark:fill-white" />
          <span>Filters</span>
        </div>
        <span className="ml-2 rounded-lg bg-gray px-2 dark:bg-design-secondary-black">
          {selectedFilters.length}
        </span>
      </DesignButton>
      {isOpen && (
        <div className="absolute right-0 min-w-max border border-white bg-muted-white dark:bg-design-black">
          <div className="px-2 py-2">
            <DesignCheckbox
              id="deliveredCheck"
              label="Delivered"
              value="DELIVERY"
              checked={selectedFilters.some((x) => x === 'DELIVERY')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="canceledCheck"
              label="Canceled"
              value="CANCELLATION"
              checked={selectedFilters.some((x) => x === 'CANCELLATION')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="pickupCheck"
              label="Pickup"
              value="PICKUP"
              checked={selectedFilters.some((x) => x === 'PICKUP')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="standardRetourCheck"
              label="Standard Retour"
              value="STANDARD_RETOUR"
              checked={selectedFilters.some((x) => x === 'STANDARD_RETOUR')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="pickPackRetourCheck"
              label="Pick Pack Retour"
              value="PICK_PACK_RETOUR"
              checked={selectedFilters.some((x) => x === 'PICK_PACK_RETOUR')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="lockerVisitCheck"
              label="Locker Visit"
              value="LOCKER_VISIT"
              checked={selectedFilters.some((x) => x === 'LOCKER_VISIT')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="pudoVisitCheck"
              label="PUDO Visit"
              value="PUDO_VISIT"
              checked={selectedFilters.some((x) => x === 'PUDO_VISIT')}
              onChange={filterHandler}
            />
          </div>
          <div className="px-2 py-2">
            <DesignCheckbox
              id="c2cPickupCheck"
              label="C2C Pickup"
              value="C2C_PICKUP"
              checked={selectedFilters.some((x) => x === 'C2C_PICKUP')}
              onChange={filterHandler}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EventsFilteringDropdown;
